const cardMasonryBlocks = document.querySelectorAll('.block-card-masonry');
const cardMasonryBlockCards = document.querySelectorAll(
	'.block-card-masonry__card'
);

if (cardMasonryBlocks.length > 0) {
	cardMasonryBlocks.forEach((block) => {
		const cards = block.querySelectorAll('.block-card-masonry__card');

		if (cards.length > 0) {
			cards.forEach((card) => {
				const heading = card.querySelector('.wp-block-heading');
				const blockObserver = new ResizeObserver((entries) => {
					entries.forEach(() => {
						const inner = entries[0].target.querySelector(
							'.block-card-masonry__card-inner'
						);

						inner?.style.setProperty(
							'--heading-height',
							`${heading?.offsetHeight}px`
						);
					});
				});

				blockObserver.observe(card);

				if (heading) {
					heading.addEventListener('click', () => {
						toggleCardActive(
							card,
							card.classList.contains('active')
						);
					});
				}
			});
		}
	});
}

const toggleCardActive = (activeCard, closeCard = false) => {
	if (closeCard) {
		activeCard.classList.remove('active');
	} else {
		cardMasonryBlockCards.forEach((card) => {
			if (card === activeCard) {
				card.classList.add('active');
			} else {
				card.classList.remove('active');
			}
		});
	}
};
